import React from "react";
import { Controller, useWatch } from "react-hook-form";
import { ErrorLabel } from "../../../form-inputs/shared/error-label";
import { Select, Textarea } from "../../../form-inputs/inputs";

export const UpcReasonFormFields = ({ index, upcIndex, upc, contextKey, control, productModifier, selectedTask, error, rejectReasonOptions }) => {
    const selectedReason = useWatch({
        control,
        name: `rejectTasks[${index}].upcs[${upcIndex}].reason`,
    });
    const { upcs } = error;
    const productModifierLabel = `-${productModifier}`;
    const upcLabel = `${upc}${productModifier ? productModifierLabel : ""}`;

    return (
        <>
            <div className="flex justify-content-between align-center">
                <div className="flex-column flex-1 m-r-28">
                    <Controller
                        defaultValue={upc}
                        name={`rejectTasks[${index}].upcs[${upcIndex}].upc`}
                        control={control}
                        render={({ field }) => (
                            <input
                                {...field}
                                type="hidden"
                            />
                        )}
                    />
                    <div className="flex-1">
                        <strong>UPC: </strong> {upcLabel}
                        {}
                    </div>
                    <Controller
                        defaultValue={contextKey}
                        name={`rejectTasks[${index}].upcs[${upcIndex}].contextKey`}
                        control={control}
                        render={({ field }) => (
                            <input
                                {...field}
                                type="hidden"
                            />
                        )}
                    />
                </div>
                <div className="flex-column flex-2">
                    <div className="flex-1 txt-bold">Reject Reason:</div>
                    <Controller
                        name={`rejectTasks[${index}].upcs[${upcIndex}].reason`}
                        rules={{
                            required: "Please select reject reason",
                        }}
                        control={control}
                        disabled={!selectedTask}
                        render={({ field }) => (
                            <ErrorLabel errorMessage={upcs?.[upcIndex]?.reason?.message}>
                                <Select
                                    {...field}
                                    className="flex-2"
                                    options={rejectReasonOptions}
                                />
                            </ErrorLabel>
                        )}
                    />
                </div>
            </div>
            {selectedReason === "0" && (
                <div className="flex">
                    <div className="flex-column flex-1 m-r-28" />
                    <div className="flex-column flex-2">
                        <div className="flex-1 txt-bold">Reject Reason (Other):</div>
                        <Controller
                            name={`rejectTasks[${index}].upcs[${upcIndex}].other`}
                            rules={{
                                required: "Please describe reject reason",
                            }}
                            control={control}
                            disabled={!selectedTask}
                            render={({ field }) => (
                                <ErrorLabel errorMessage={upcs?.[upcIndex]?.other?.message}>
                                    <Textarea
                                        {...field}
                                        rows={2}
                                        className="flex-2"
                                    />
                                </ErrorLabel>
                            )}
                        />
                    </div>
                </div>
            )}
        </>
    );
};
